export default function() {
   return {
      rules: {},
      fetching: [],
      updating: [],
      definitionsLoaded: false,
      definitions: [],
   };
}
